function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from 'react';
import { EditorState, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { useCustomField } from '../../../common/hooks/useCustomField';
import classNames from 'classnames';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './index.scss';

const EditorField = ({
  name,
  value,
  onChange,
  className,
  isInvalid,
  isValid,
  toolbar,
  pasteTextAsIs,
  overideToolBar,
  ...props
}) => {
  // const [editorState, setEditorState] = useState(EditorState.createEmpty())
  // const observables = useRef<{ isDirty: boolean }>({
  //     isDirty: false
  // }).current
  const [customField, setCustomField] = useCustomField({
    name,
    value,
    onChange,
    customStates: {
      editorState: EditorState.createEmpty()
    }
  });
  useEffect(() => {
    if (!customField.dirty) {
      const {
        contentBlocks,
        entityMap
      } = htmlToDraft(value || "");
      const state = EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap));
      handleEditorStateChange(state);
    }
  }, [value]);

  const handleEditorStateChange = state => {
    setCustomField(prev => ({ ...prev,
      customStates: { ...prev.customStates,
        editorState: state
      }
    }));
  };

  const handleContentStateChange = draft => {
    const value = draftToHtml(draft); // if(onChange)
    //     onChange({name, value, target: {name, value}})

    setCustomField(prev => ({ ...prev,
      value,
      dirty: true
    })); // observables.isDirty = true
  };

  return /*#__PURE__*/React.createElement(Editor, _extends({
    handlePastedText: () => pasteTextAsIs
  }, props, {
    editorState: customField.customStates?.editorState,
    wrapperClassName: classNames("edit-wrapper", {
      "is-invalid": isInvalid,
      "is-valid": isValid
    }, className),
    editorClassName: "editor-field",
    onEditorStateChange: handleEditorStateChange,
    onContentStateChange: handleContentStateChange,
    toolbar: { ...toolbar,
      ...overideToolBar
    }
  }));
};

EditorField.defaultProps = {
  value: "",
  toolbar: {
    options: ["inline", "fontSize", "list", "link", "history", "remove"],
    inline: {
      options: ["bold", "italic", "underline"]
    },
    list: {
      options: ["unordered", "ordered"]
    }
  },
  pasteTextAsIs: false
};
export default EditorField;